module.exports = __webpack_public_path__ + "img/23_106.3c0b274b.png";